import { render, staticRenderFns } from "./CustomersPage.vue?vue&type=template&id=66b056ba"
import script from "./CustomersPage.vue?vue&type=script&lang=js"
export * from "./CustomersPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports